/**
 * Generated from ch1_p09.fla
 */
export function ch1_p09(this: Ich1_p09) {
	const background = this.background;
	ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_background.call(this.background);
	background.x = 837.25;
	background.y = 384;
	background.width = 1674.50;
	background.height = 768.00;
	background.alpha = 1.00;
	if (background.onLayout) background.onLayout();
	const island = this.island;
	ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_island.call(this.island);
	island.x = 950;
	island.y = 768;
	island.width = 934.00;
	island.height = 483.50;
	island.alpha = 1.00;
	if (island.onLayout) island.onLayout();
	const light = this.light;
	ch1_p09_hh_ch1_72dpi_p09psdAsset1ch1_p09_lightLayer230.call(this.light);
	light.x = 717.5;
	light.y = 384;
	light.width = 1435.00;
	light.height = 768.00;
	light.alpha = 1.00;
	if (light.onLayout) light.onLayout();
	const holly = this.holly;
	ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_holly.call(this.holly);
	holly.x = 421;
	holly.y = 768;
	holly.width = 669.00;
	holly.height = 709.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeLayer241.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 197.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeLayer241copy.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 197.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const lineart = this.lineart;
	ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeframelineart.call(this.lineart);
	lineart.x = 832;
	lineart.y = 363.5;
	lineart.width = 1664.00;
	lineart.height = 727.00;
	lineart.alpha = 0.38;
	if (lineart.onLayout) lineart.onLayout();
	return this;
}
function ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_background(this: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p09_background", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_island(this: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_island) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p09_island.png", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p09_hh_ch1_72dpi_p09psdAsset1ch1_p09_lightLayer230(this: Ich1_p09_hh_ch1_72dpi_p09psdAsset1ch1_p09_lightLayer230) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer230", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_holly(this: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p09_holly.png", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeLayer241(this: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeLayer241) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer241", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeLayer241copy(this: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeLayer241copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer241copy", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeframelineart(this: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeframelineart) {
	if (this.setLayoutTexture) this.setLayoutTexture("framelineart", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich1_p09Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich1_p09Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich1_p09Sprite extends Ich1_p09Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich1_p09Text extends Ich1_p09Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich1_p09Polygon extends Array<number> {
}
interface Ich1_p09 {
	readonly background: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_background;
	readonly island: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_island;
	readonly light: Ich1_p09_hh_ch1_72dpi_p09psdAsset1ch1_p09_lightLayer230;
	readonly holly: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_holly;
	readonly frameRight: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeLayer241;
	readonly frameLeft: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeLayer241copy;
	readonly lineart: Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeframelineart;
}
interface Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_background extends Ich1_p09Sprite {
}
interface Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_island extends Ich1_p09Sprite {
}
interface Ich1_p09_hh_ch1_72dpi_p09psdAsset1ch1_p09_lightLayer230 extends Ich1_p09Sprite {
}
interface Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_holly extends Ich1_p09Sprite {
}
interface Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeLayer241 extends Ich1_p09Sprite {
}
interface Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeLayer241copy extends Ich1_p09Sprite {
}
interface Ich1_p09_hh_ch1_72dpi_p09psdAssetP9ch1_p09_wcframeframelineart extends Ich1_p09Sprite {
}
